import { cn } from '@/lib/utils/cn';

/**
 * T-0100 — User chat bubble. Right-aligned, paper-100 background,
 * asymmetric radius matching the prototype's
 * `border-radius: 12px 12px 4px 12px`.
 *
 * Per the ticket scope (§Layout): "User messages: right-aligned,
 * paper-100 bg, no chip decoration." The bubble is deliberately bare
 * — no posture chip, no provenance chip, no avatar — to maintain the
 * single AI surface contract (any decoration here muddies the
 * "this came from the model vs. this came from the user" reading).
 *
 * Visual contract: `design_handoff_caliber_v2/prototype/screens-engagement.js`
 * → `chatMsgUser(...)`.
 */
export interface UserMessageProps {
  content: string;
  className?: string;
}

export function UserMessage({ content, className }: UserMessageProps) {
  return (
    <div className={cn('flex justify-end', className)}>
      <div
        className={cn(
          // Bubble: right-aligned, paper-100, asymmetric corner.
          // `min-w-0` + `overflow-wrap:anywhere` keep a pasted URL inside the
          // bubble at tablet width (C2-35).
          'min-w-0 max-w-[520px] bg-paper-100 px-[14px] py-[10px] text-body text-ink-900 [overflow-wrap:anywhere]',
          'rounded-[12px] rounded-br-[4px]',
        )}
      >
        {/* `whitespace-pre-wrap` so multi-line questions (Shift+Enter) keep
            their newlines without us building a markdown layer. */}
        <p className="whitespace-pre-wrap">{content}</p>
      </div>
    </div>
  );
}
